import React from "react";
import { Table, Tooltip, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { transformProtocolToSessions } from "../../../services/functions";

export const TransparentTable = styled(Table)`
  background: transparent !important;
  color: #426bba;

  .ant-table,
  .ant-table-container,
  .ant-table-content,
  .ant-table-body {
    background: transparent !important;
    color: #426bba;
  }

  /* Header cells */
  .ant-table-thead > tr > th {
    background: #426bba !important;
    color: #FFF !important;
    border-bottom: 1px solid #bfd3f2 !important;
    border-right: 1px solid #bfd3f2 !important;
    font-weight: 600;
  }

  /* Body cells */
  .ant-table-tbody > tr > td {
    background: transparent !important;
    color: #426bba !important;
    border-bottom: 1px solid #bfd3f2 !important;
    border-right: 1px solid #bfd3f2 !important;
  }

  /* Remove extra border on last column */
  .ant-table-thead > tr > th:last-child,
  .ant-table-tbody > tr > td:last-child {
    border-right: none !important;
  }

  /* ===== CLICKABLE CURSOR ===== */
  .ant-table-tbody > tr {
    cursor: pointer;
  }

  /* Hover effect */
  .ant-table-tbody > tr:hover > td {
    background: rgba(66, 107, 186, 0.08) !important;
  }

  /* Active row highlight */
  .active-session-row td {
    background: rgba(66, 107, 186, 0.15) !important;
  }

  /* Outer border */
  &.ant-table-bordered {
    border: 1px solid #bfd3f2 !important;
  }

  /* OUTER BORDER FIX */
  .ant-table-container {
    border: 1px solid #bfd3f2 !important;
    border-radius: 8px;
    overflow: hidden;
  }

  /* Pagination text */
  .ant-pagination-item,
  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-item-link {
    color: #426bba !important;
    border-color: #bfd3f2 !important;
  }

  /* Active page */
  .ant-pagination-item-active {
    border-color: #bfd3f2 !important;
  }

  .ant-pagination-item-active a {
    color: #426bba !important;
  }
`;

export default function SessionHistoryTable({ protocols, onSelectSession, onDeleteSession, loading }) {
    const sessionRows = transformProtocolToSessions(protocols);

    const handleDelete = (e, record) => {
        // Stop row click from firing when delete is clicked
        e.stopPropagation();
        onDeleteSession?.(record);
    };

    const columns = [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            width: 90,
        },
        {
            title: "Protocol",
            dataIndex: "protocol",
            key: "protocol",
            ellipsis: true,
        },
        {
            title: "",
            key: "action",
            width: 40,
            render: (_, record) => (
                <Popconfirm
                    title="Delete this protocol?"
                    description="This action cannot be undone."
                    okText="Yes, Delete"
                    cancelText="Cancel"
                    okButtonProps={{ danger: true }}
                    onConfirm={(e) => handleDelete(e, record)}
                    onCancel={(e) => e.stopPropagation()}
                >
                    <Tooltip title="Delete protocol">
                        <DeleteOutlined
                            style={{ color: "#ff4d4f", cursor: "pointer" }}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </Tooltip>
                </Popconfirm>
            ),
        },
    ];

    return (
        <TransparentTable
            rowKey="protocol_id"
            columns={columns}
            dataSource={sessionRows}
            loading={loading}
            size="small"
            pagination={{
                pageSize: 5,
                size: "small",
            }}
            bordered
            rowClassName={(record) =>
                record.isActive ? "active-session-row" : ""
            }
            onRow={(record) => ({
                onClick: () => {
                    onSelectSession?.(record);
                },
            })}
            style={{ background: "transparent" }}
        />
    );
}